import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';

const linkStyle = "block px-4 py-2 text-sm text-muted-foreground hover:bg-accent transition-colors";

function AdminDropdown() {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const location = useLocation();

    // Função para fechar o dropdown ao clicar fora
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);

    // Fecha o dropdown quando a rota muda
    useEffect(() => {
        setIsDropdownOpen(false);
    }, [location.pathname]);

    const getLinkClass = (path) => {
        const isActive = location.pathname.startsWith(path);
        return `${linkStyle} ${isActive ? 'bg-accent text-primary font-semibold' : ''}`;
    };

    return (
        <div className="relative" ref={dropdownRef}>
            <button 
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="text-sm font-medium text-muted-foreground transition-colors hover:text-primary cursor-pointer flex items-center p-2 -m-2 rounded-md hover:bg-accent/50"
                aria-expanded={isDropdownOpen}
                aria-controls="admin-menu-dropdown"
                aria-label="Menu de Administração"
            >
                Admin
                <ChevronDown className={`ml-1 h-4 w-4 transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : 'rotate-0'}`} />
            </button>
            
            {isDropdownOpen && (
                <div 
                    id="admin-menu-dropdown"
                    className="absolute left-0 mt-2 w-48 bg-background border rounded-md shadow-lg z-20 origin-top-left animate-in fade-in-0 zoom-in-95"
                >
                    <Link to="/admin/eventos" className={getLinkClass('/admin/eventos')}>Gerenciar Eventos</Link>
                    <Link to="/admin/checkin" className={getLinkClass('/admin/checkin')}>Check-in</Link>
                    <Link to="/admin/inscricoes" className={getLinkClass('/admin/inscricoes')}>Gerenciar Inscrições</Link>
                    <Link to="/admin/usuarios" className={getLinkClass('/admin/usuarios')}>Gerenciar Usuários</Link>
                </div>
            )}
        </div>
    );
}

export default AdminDropdown;